<section class="ruoli-page">
  <div class="container">
    <!-- Header -->
    <section class="page-header">
      <div class="title-section">
        <h1 class="title-text">
          <span class="material-symbols-outlined">badge</span>
          <span>Ruoli</span>
        </h1>
        <div class="selected-filters-container" *ngIf="searchText">
          <span class="filter-chip">
            <span class="chip-label">Ricerca: {{ searchText }}</span>
            <button
              type="button"
              class="chip-remove"
              (click)="clearSearch()"
              aria-label="Rimuovi filtro"
            >
              <i class="pi pi-times"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="header-actions">
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Nuovo Ruolo"
          class="add-button p-button-rounded"
          aria-label="Aggiungi nuovo ruolo"
          *ngIf="canModify()"
          (click)="openCreateDialog()"
        ></button>
        <div class="stats-block">
          <div class="stat-card primary">
            <span class="stat-label">Totale Ruoli</span>
            <span class="stat-value">{{ ruoli.length }}</span>
          </div>
          <div class="stat-card secondary" *ngIf="searchText">
            <span class="stat-label">Risultati</span>
            <span class="stat-value stat-value-filtered">{{ filteredRuoli.length }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Sezione ricerca -->
    <section class="search-section">
      <div class="search-row-compact">
        <div class="search-field">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
              placeholder="Cerca per descrizione ..."
            />
          </span>
        </div>
        <button
          *ngIf="searchText"
          type="button"
          class="clear-search-btn"
          (click)="clearSearch()"
          pTooltip="Cancella ricerca"
          tooltipPosition="top"
        >
          <i class="pi pi-times"></i>
          <span>Cancella</span>
        </button>
      </div>
    </section>

    <!-- Sezione tabella -->
    <section class="table-section" *ngIf="ruoli.length > 0; else noRuoli">
      <div class="table-card">
        <div class="table-content">
          <p-table
            [value]="filteredRuoli"
            [paginator]="false"
            [resizableColumns]="true"
            [responsiveLayout]="'scroll'"
            [loading]="loading"
            class="ruoli-table"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pResizableColumn pSortableColumn="descrizione" style="min-width: 260px">
                  Descrizione
                </th>
                <th pResizableColumn pSortableColumn="numeroReferenze" style="min-width: 140px; text-align: center;">
                  Numero Referenze
                </th>
                <th style="width: 120px; text-align: center;" *ngIf="canModify()">
                  Azioni
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ruolo>
              <tr class="ruolo-row">
                <td>
                  <span class="codice-ruolo">{{ ruolo.descrizione | uppercase }}</span>
                </td>
                <td style="text-align: center;">
                  <span
                    class="referenze-count"
                    [class.clickable]="ruolo.numeroReferenze && ruolo.numeroReferenze > 0"
                    [pTooltip]="ruolo.numeroReferenze && ruolo.numeroReferenze > 0 ? 'Clicca per vedere le referenze con questo ruolo' : ''"
                    tooltipPosition="top"
                  >
                    {{ ruolo.numeroReferenze || 0 }}
                  </span>
                </td>
                <td class="actions-cell" *ngIf="canModify()">
                  <div class="action-buttons">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-text p-button-info action-btn edit-btn"
                      pTooltip="Modifica descrizione ruolo"
                      tooltipPosition="top"
                      (click)="startEdit(ruolo)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-text p-button-danger action-btn delete-btn"
                      [pTooltip]="ruolo.numeroReferenze && ruolo.numeroReferenze > 0 ? 'Non è possibile eliminare un ruolo con referenze associate (' + ruolo.numeroReferenze + ' referenze)' : 'Elimina ruolo'"
                      tooltipPosition="top"
                      [disabled]="ruolo.numeroReferenze && ruolo.numeroReferenze > 0"
                      (click)="confirmDelete(ruolo)"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="3" class="empty-message">
                  Nessun ruolo disponibile
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="3" class="loading-message">
                  <i class="pi pi-spin pi-spinner"></i>
                  Caricamento in corso...
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </section>

    <ng-template #noRuoli>
      <section class="empty-state">
        <div class="empty-card">
          <span class="material-symbols-outlined empty-icon">info</span>
          <h2>Nessun ruolo trovato</h2>
          <p>
            Non sono presenti ruoli nel database. Verifica la connessione al backend o contatta l'amministratore.
          </p>
        </div>
      </section>
    </ng-template>

    <!-- Dialog Creazione/Modifica Ruolo -->
    <p-dialog
      [(visible)]="ruoloDialogVisible"
      [modal]="true"
      [closable]="!savingEdit"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '90vw', maxWidth: '500px' }"
      styleClass="ruolo-dialog"
      [dismissableMask]="!savingEdit"
    >
      <ng-template pTemplate="header">
        <div class="dialog-header">
          <div class="dialog-title">
            <i class="pi pi-id-card dialog-icon"></i>
            <h2>{{ dialogMode === 'create' ? 'Nuovo Ruolo' : 'Modifica Ruolo' }}</h2>
          </div>
        </div>
      </ng-template>

      <div class="dialog-content">
        <div class="form-container">
          <div class="form-field">
            <label for="descrizione">
              Descrizione ruolo
              <span class="required">*</span>
            </label>
            <input
              id="descrizione"
              type="text"
              pInputText
              [(ngModel)]="editingDescrizione"
              placeholder="Inserisci la descrizione del ruolo"
              [style]="{ width: '100%' }"
              [disabled]="savingEdit"
            />
          </div>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="dialog-footer">
          <button
            pButton
            type="button"
            label="Annulla"
            icon="pi pi-times"
            class="p-button-text"
            (click)="cancelEdit()"
            [disabled]="savingEdit"
          ></button>
          <button
            pButton
            type="button"
            [label]="dialogMode === 'create' ? 'Crea Ruolo' : 'Salva'"
            icon="pi pi-check"
            class="p-button-primary"
            (click)="saveRuolo()"
            [disabled]="savingEdit || !editingDescrizione.trim()"
            [loading]="savingEdit"
          ></button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Confirm Dialog per eliminazione ruolo -->
    <p-confirmDialog></p-confirmDialog>
  </div>
</section>

